// TODO remove
/* eslint-disable */

import { Link as _Link, useHistory } from "react-router-dom";

const Link = (props) => {
    const history = useHistory();
    const delayClick = (e) => {
        e.preventDefault();
        setTimeout(() => {
            history.push(props.to);
        }, 1);
    };
    return (
        <_Link {...props} onClick={(e) => delayClick(e)}>
            {props.children}
        </_Link>
    );
};

export default Link;
